import React from 'react';
import { Link } from "react-router-dom";
import { Grid, GridCell } from 'rmwc/Grid';

const Footer = props => (
  <div style={{marginLeft:"30px"}}>
    <Grid>
      <GridCell span={6} phone={4}>
      Copyright © <a href="https://www.rockingrose.com" target="_blank" rel="noopener noreferrer">Rocking Rose</a> 2018 . All Rights Reserved
      </GridCell>
      <GridCell  span={6} phone={4}>
      <Link to={'./privacy'}>Privacy Policy & Terms of Service</Link>
      </GridCell>
    </Grid>
  </div>
)

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/Footer.js